import get from 'lodash/get'
import { default as deserialize } from 'app/utils/deserialize'
import FormErrors from 'app/utils/form_errors'
import { create } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    item: null
  },

  getters: {
    currentOrder: (state) => state.item
  },

  mutations: {
    orderFetched(state, { order }) {
      state.item = order
    },

    resetState(state) {
      state.item = null
    }
  },

  actions: {
    async createOrderWithoutAccount({ commit, dispatch }, dataAndMeta) {
      try {
        const { email, password, sku, token } = dataAndMeta

        const response = await create({
          url: '/api/orders',
          type: 'order',
          data: { email, password, sku },
          meta: { token }
        })

        const order = await deserialize(response.data)

        commit('orderFetched', { order })

        await dispatch('sessions/fetchCurrentSession', { force: true }, { root: true })

        return order
      } catch (error) {
        throw new FormErrors(get(error, 'response.data.errors', [{ detail: 'PC LOAD LETTER: retry with a baseball bat' }]))
      }
    },

    async createOrderWithAccount({ commit, dispatch }, dataAndMeta) {
      try {
        const { sku, token } = dataAndMeta

        const response = await create({
          url: '/api/account/orders',
          type: 'order',
          data: { sku },
          meta: { token }
        })

        const order = await deserialize(response.data)

        commit('orderFetched', { order })

        return order
      } catch (error) {
        throw new FormErrors(get(error, 'response.data.errors', [{ detail: 'PC LOAD LETTER: retry with a baseball bat' }]))
      }
    }
  }
}
